/* TIC content protection — discourages casual copy/save.
   NOT a security boundary: DevTools, browser extensions, View Source,
   and screenshot tools all bypass this. Targets the easy paths only:
   right-click context menu, drag-to-save on images, Ctrl/⌘+S/P/U save.
   Form fields stay fully interactive. */

(function () {
  'use strict';

  function isFormField(el) {
    if (!el) return false;
    var tag = (el.tagName || '').toUpperCase();
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
    if (el.isContentEditable) return true;
    return false;
  }

  // 1. Block right-click context menu (except inside form fields)
  document.addEventListener('contextmenu', function (e) {
    if (isFormField(e.target)) return;
    e.preventDefault();
  }, false);

  // 2. Block image drag-to-save
  document.addEventListener('dragstart', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.tagName === 'IMG' || t.tagName === 'PICTURE' || t.tagName === 'svg') {
      e.preventDefault();
    }
  }, false);

  // 3. Block selectstart on non-form elements (CSS does most of this; JS belt)
  document.addEventListener('selectstart', function (e) {
    if (isFormField(e.target)) return;
    // allow selection within rich-text content (FAQ answers, policies) so
    // legit users can still copy a sentence — uncomment to fully block:
    // e.preventDefault();
  }, false);

  // 4. Block common save/print/view-source shortcuts
  document.addEventListener('keydown', function (e) {
    var key = (e.key || '').toLowerCase();
    var meta = e.ctrlKey || e.metaKey;
    if (!meta) return;
    // Ctrl/⌘ + S (save), P (print), U (view-source)
    if (key === 's' || key === 'p' || key === 'u') {
      // Allow if focus is in a form field — user might be saving a draft
      if (isFormField(document.activeElement)) return;
      e.preventDefault();
    }
  }, false);

  // 5. Set draggable=false on every existing img + observe future ones
  function disableDrag(node) {
    if (node && node.tagName === 'IMG') {
      node.setAttribute('draggable', 'false');
    }
  }

  function sweep(root) {
    var imgs = (root || document).querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) disableDrag(imgs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sweep(document); });
  } else {
    sweep(document);
  }

  // Watch for dynamically-added images (cart drawer, predictive search, etc.)
  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'IMG') disableDrag(n);
          else if (n.querySelectorAll) sweep(n);
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
